module.exports = __webpack_public_path__ + "static/media/boys-tackle.92fb380a.mov";